import { useSelector } from "react-redux";
import { useCallback, useState } from "react";
import { Grid, Zoom } from "@material-ui/core";
import { trim } from "../../helpers";
import "./dashboard.scss";
import { Skeleton } from "@material-ui/lab";
import { Link } from "@material-ui/core";
import { NavLink } from "react-router-dom";
// import Social from "./social";
import { IReduxState } from "../../store/slices/state.interface";
import Centerpng from "../../assets/icons/centerpng.png";
import Footerpng from "../../assets/icons/footer-diamond.png";
import { IAppSlice } from "../../store/slices/app-slice";

function Dashboard() {
    const isAppLoading = useSelector<IReduxState, boolean>(state => state.app.loading);
    const app = useSelector<IReduxState, IAppSlice>(state => state.app);

    const trimmedStakingAPY = trim(app.stakingAPY * 100, 1);

    const checkPage = useCallback((location: any, page: string): boolean => {
        const currentPath = location.pathname.replace("/", "");
        if (currentPath.indexOf("dashboard") >= 0 && page === "dashboard") {
            return true;
        }
        if (currentPath.indexOf("stake") >= 0 && page === "stake") {
            return true;
        }
        if (currentPath.indexOf("mints") >= 0 && page === "mints") {
            return true;
        }
        if (currentPath.indexOf("calculator") >= 0 && page === "calculator") {
            return true;
        }
        return false;
    }, []);

    return (
        <div className="dashboard-view">
            <div className="dashboard-infos-wrap">
                <Zoom in={true}>
                    <Grid container spacing={4} className={"dashboard-container"}>
                        {/* <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Social />
                        </Grid> */}
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <Grid container spacing={2}>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <img src={Centerpng} className={"centerpng"} />
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <div className="header-title-mobile">No Games, just true wealth!</div>
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12} className={"board-text"}>
                                    {/* <h3>1, 003, 025, 500, 040, 007, 088, 009, 120, 002, 004, 033, 010, 100, 420, 006, 057, 090, 000% APY</h3> */}
                                    {/* <p>
                                        One Septen-decillion, Three Sexdecillion, Twenty-Five Quindecillion, Five Hundred Quattuordecillion, Forty Tredecillion, Seven Duodecillion,
                                        Eighty-Eight Undecillion, Nine Decillion, One Hundred Twenty Nonillion, Two Octillion, Four Septillion, Thirty-Three Sextillion, Ten
                                        Quintillion, One Hundred Quadrillion, Four Hundred Twenty Trillion, Six Billion, Fifty-Seven Million and Ninety Thousand Percent APY.
                                    </p>
                                    <p>
                                        Rebase every 8 hours. 1095 Rebases per year. This Massive APY was only possible by Super Enriching the Treasury with investment funds. This
                                        cosmic space time continuum APY cannot be maintained long term. Sustainable APY’s in the first week should be around 8 billion %. Long term
                                        stability will range from 3 billion and 700,000 APY.
                                    </p> */}
                                    {/* <p>
                                        In order to sustain such gigantic APY’s we’ve added profits from our Diamond Mining technology. Our proprietary Diamond Mining technology
                                        mines Kadena and Ethereum simultaneously! Our mission is to reduce energy consumption worldwide. The Sun is the only energy source we should
                                        ever need. All Diamond Miners run on solar panels. We give all crypto miners an energy efficient solution which should prevent them from
                                        ordering more power hungry asic miners.
                                    </p> */}
                                    <p>Next Generation Hedge Fund</p>
                                    <p>No VC's, No Pre-Sells, No Dilution</p>
                                    <p>$1,000,000 Giveaway</p>
                                    <p>Mission to Mars</p>
                                    <br />
                                    <p>Elite Team: 2 hedge fund business owners,</p>
                                    <p>a Bank of America VP and a SpaceX engineer</p>
                                    {/* <h2>Missions:</h2>
                                    <ul>
                                        <li>Providing extreme wealth and knowledge! </li>
                                        <li>Reducing energy consumption worldwide! </li>
                                        <li>Making humanity multiplanetary! </li>
                                        <li>
                                            Inviting 1 Diamond ARMY member on a trip to MARS with our friends at SpaceX. Booking (2022) We will bring the cargo of many messages
                                            from the whole Diamond Army! Your message will be heard and recorded on MARS! DiamondBank to be the first bank on MARS using a crypto
                                            reserve currency. This will be the story your grandkids tell their grandkids! How their Great Great Grandparents helped colonize mars!
                                        </li>
                                    </ul> */}
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container lg={6} md={6} sm={6} xs={12} direction="column" justifyContent="space-between" alignItems="center">
                            <Grid item>
                                <Grid container spacing={4} className={"right-content"}>
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                        <div className="dashboard-card">
                                            <p className="card-title">APY</p>
                                            <p className="card-value" style={{ color: "#0096FF " }}>
                                                {isAppLoading ? (
                                                    <Skeleton width="250px" />
                                                ) : (
                                                    `${
                                                        trimmedStakingAPY.length > 3
                                                            ? new Intl.NumberFormat().format(Math.round(Number(trimmedStakingAPY)))
                                                            : Number.parseFloat(trimmedStakingAPY).toPrecision(10)
                                                    }%`
                                                )}
                                            </p>
                                        </div>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={12}>
                                        <div className="dashboard-card">
                                            <p className="card-title">$DB Price</p>
                                            <p className="card-value">{isAppLoading ? <Skeleton width="100px" /> : `$${trim(app.marketPrice, 2)}`}</p>
                                        </div>
                                    </Grid>

                                    <Grid item lg={6} md={6} sm={6} xs={12}>
                                        <div className="dashboard-card">
                                            <p className="card-title">Market Cap</p>
                                            <p className="card-value">
                                                {isAppLoading ? (
                                                    <Skeleton width="160px" />
                                                ) : (
                                                    new Intl.NumberFormat("en-US", {
                                                        style: "currency",
                                                        currency: "USD",
                                                        maximumFractionDigits: 0,
                                                        minimumFractionDigits: 0,
                                                    }).format(app.marketCap)
                                                )}
                                            </p>
                                        </div>
                                    </Grid>

                                    <Grid item lg={6} md={6} sm={6} xs={12}>
                                        <div className="dashboard-card">
                                            <p className="card-title">Total Value Locked</p>
                                            <p className="card-value">
                                                {isAppLoading ? (
                                                    <Skeleton width="250px" />
                                                ) : (
                                                    new Intl.NumberFormat("en-US", {
                                                        style: "currency",
                                                        currency: "USD",
                                                        maximumFractionDigits: 0,
                                                        minimumFractionDigits: 0,
                                                    }).format(app.stakingTVL)
                                                )}
                                            </p>
                                        </div>
                                    </Grid>

                                    <Grid item lg={6} md={6} sm={6} xs={12}>
                                        <div className="dashboard-card">
                                            <p className="card-title">Treasury Balance</p>
                                            <p className="card-value">
                                                {isAppLoading ? (
                                                    <Skeleton width="250px" />
                                                ) : (
                                                    new Intl.NumberFormat("en-US", {
                                                        style: "currency",
                                                        currency: "USD",
                                                        maximumFractionDigits: 0,
                                                        minimumFractionDigits: 0,
                                                    }).format(app.treasuryBalance)
                                                )}
                                            </p>
                                        </div>
                                    </Grid>

                                    <Grid item lg={6} md={6} sm={6} xs={12}>
                                        <div className="dashboard-card">
                                            <p className="card-title">Diamond Supply</p>
                                            <p className="card-value">
                                                {isAppLoading ? (
                                                    <Skeleton width="250px" />
                                                ) : (
                                                    `${new Intl.NumberFormat("en-US", {
                                                        maximumFractionDigits: 0,
                                                        minimumFractionDigits: 0,
                                                    }).format(app.totalSupply)}`
                                                )}
                                            </p>
                                        </div>
                                    </Grid>

                                    {/* <Grid item lg={6} md={6} sm={6} xs={12}>
                                        <div className="dashboard-card">
                                            <p className="card-title">Diamond Supply</p>
                                            <p className="card-value">
                                                {isAppLoading ? (
                                                    <Skeleton width="250px" />
                                                ) : (
                                                    `${new Intl.NumberFormat("en-US", {
                                                        maximumFractionDigits: 0,
                                                        minimumFractionDigits: 0,
                                                    }).format(app.circSupply)}
                                                    /
                                                    ${new Intl.NumberFormat("en-US", {
                                                        maximumFractionDigits: 0,
                                                        minimumFractionDigits: 0,
                                                    }).format(app.totalSupply)}`
                                                )}
                                            </p>
                                        </div>
                                    </Grid> */}

                                    <Grid item lg={6} md={6} sm={6} xs={12}>
                                        <div className="dashboard-card">
                                            <p className="card-title">Backing per $DB</p>
                                            <p className="card-value">
                                                {isAppLoading ? (
                                                    <Skeleton width="250px" />
                                                ) : (
                                                    new Intl.NumberFormat("en-US", {
                                                        style: "currency",
                                                        currency: "USD",
                                                        maximumFractionDigits: 0,
                                                        minimumFractionDigits: 0,
                                                    }).format(app.rfv)
                                                )}
                                            </p>
                                        </div>
                                    </Grid>

                                    <Grid item lg={6} md={6} sm={6} xs={12}>
                                        <div className="dashboard-card">
                                            <p className="card-title">Rebase Index Since Start</p>
                                            <p className="card-value">{isAppLoading ? <Skeleton width="250px" /> : `${trim(Number(app.currentIndex), 2)} DB`}</p>
                                        </div>
                                    </Grid>

                                    <Grid item lg={6} md={6} sm={6} xs={12}>
                                        <div className="dashboard-card">
                                            <Link style={{ textAlign: "center" }} component={NavLink} id="bond-nav" to="/mining" className={"button-link"}>
                                                <p className="card-title">Diamond Nodes</p>
                                                <p className="card-value">coming soon</p>
                                            </Link>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item>
                                <Grid container spacing={4} className={"buy-bond-button"}>
                                    <Grid item lg={6} md={6} sm={6} xs={6} justifyContent="flex-end">
                                        <Grid container direction="row" justifyContent="flex-end" alignItems="center">
                                            <Link
                                                href={"https://traderjoexyz.com/#/trade?inputCurrency=&outputCurrency=0xb392c73e48147BEB3EAAA315C2b41D330b2181f0"}
                                                target="_blank"
                                                className={"button-link"}
                                                style={{ minWidth: 120 }}
                                            >
                                                <div className="dashboard-button">
                                                    <p>Buy</p>
                                                </div>
                                            </Link>
                                        </Grid>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={6} justifyContent="flex-start">
                                        <Grid container direction="row" justifyContent="flex-start" alignItems="center">
                                            <Link
                                                component={NavLink}
                                                id="bond-nav"
                                                to="/mints"
                                                isActive={(match: any, location: any) => {
                                                    return checkPage(location, "mints");
                                                }}
                                                className={"button-link"}
                                                style={{ minWidth: 120 }}
                                            >
                                                <div className="dashboard-button">
                                                    <p>Bond</p>
                                                </div>
                                            </Link>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <img src={Footerpng} className={"footerpng"} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Zoom>
            </div>
        </div>
    );
}

export default Dashboard;
